import React, {useState, useEffect, useRef} from "react";
import {
    Input,
    Tag,
    Dropdown,
    MenuProps,
    Space,
    Card,
    Button,
    Checkbox,
    message,
    Divider,
    Form,
    Drawer,
    FloatButton,
    Modal,
    Select, AutoComplete, Tabs
} from "antd";
import {
    CloseOutlined,
    CopyOutlined,
    DeleteOutlined,
    HistoryOutlined,
    ImportOutlined,
    ReloadOutlined,
    SendOutlined,
    ShareAltOutlined,
    UploadOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import {Header} from "antd/es/layout/layout";
import {VscChromeMaximize, VscChromeMinimize, VscChromeRestore} from "react-icons/vsc";
import {
    MdOutlineAccountCircle,
    MdOutlineClose,
    MdOutlineKeyboard,
    MdOutlinePause,
    MdOutlineRefresh, MdOutlineSettings
} from "react-icons/md";
import {BiSolidArrowToTop, BiStopCircle} from "react-icons/bi";
import {PiStopCircleBold} from "react-icons/pi";
import copy from "copy-to-clipboard";
import Cookies from "js-cookie";
import TextArea from "antd/es/input/TextArea";
import "../kuai_message.css";

const DICT = [
    "apple", "app", "application", "banana", "band", "bandwidth",
    "cat", "catalog", "caterpillar", "dog", "door", "docker",
    "electron", "element", "elegant", "search", "season",
    "react", "redux", "router", "typescript", "tailwind"
];

const Employeemanage_SearchChain: React.FC = () => {
    const [query, setQuery] = useState("");
    const [chain, setChain] = useState<string[]>([]);
    const [suggests, setSuggests] = useState<string[]>([]);
    const [results, setResults] = useState<string[]>([]);
    const [open, setOpen] = useState(false);
    const [user_token, setuser_token] = useState('')
    const SelectRef = useRef(null);
    const inputRef = useRef(null);
    const [activeQuickTab, setActiveQuickTab] = useState('1');

    const [is_maximize, setis_maximize]=useState('unmaximize')
    const send_message = (message_v: any) => {




    }


    const copy_clipbord = (message_v: any) => {


        copy(message_v)
message.success('复制成功')

    }

    useEffect(() => {


        employeemanage_ddd('1')
        setshow_quickly_all_select_info({value1: '1', value2: '', value3: '', time: data_time})
        setshow_quickly_all_select_log({message: 'init', value: '', time: data_time})
    }, []);



    // 搜索建议
    useEffect(() => {
        if (!query.trim()) {
            setSuggests([]);
            setOpen(false);
            return;
        }

        const q = query.toLowerCase();
        const list = DICT.filter(w => w.includes(q)).slice(0, 8);
        setSuggests(list);
        setOpen(list.length > 0);
    }, [query]);

    // 添加词到“连锁标签
    const addTag = (word: string) => {
        if (!word.trim()) return;
        if (!chain.includes(word)) {
            setChain([...chain, word]);
            doSearch(word);
        }
        setQuery("");
        setOpen(false);
    };

    // 删除标签
    const removeTag = (word: string) => {
        setChain(chain.filter(t => t !== word));
    };

    // 模拟搜索结果
    const doSearch = (word: string) => {
        const matched = DICT.filter(w => w.includes(word.toLowerCase()));
        setResults(matched);
    };

    const items: MenuProps['items'] =
        chain.map(item=>({key:'1',label:(
                <a target="_blank" rel="noopener noreferrer" >
                    1st menu item
                </a>
            )}))
    ;


    let data_time=dayjs().unix()






    const [employeemanage_quickly_hs_serach_select_info, setemployeemanage_quickly_hs_serach_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [employeemanage_quickly_hs_serach_select_log, setemployeemanage_quickly_hs_serach_select_log] = useState({message: '', value: '', time: 0})
    const employeemanage_quickly_hs_serach = (e1: any) => {

        setemployeemanage_quickly_hs_serach_select_log({message: 'click', value: '', time: data_time})



        setemployeemanage_quickly_hs_serach_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

    const [return_data_employeemanage_quickly_hs_serach,setreturn_data_employeemanage_quickly_hs_serach]=useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "160",
                "uuid": null,
                "title_name": "11",
                "sub_txt1": null,
                "sub_txt2": null,
                "parent_id": null,
                "parent_uuid": null,
                "mag1": null,
                "mag2": null,
                "status": "en",
                "tab_state": null,
                "country_code": null,
                "country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761",
                "user_access": null,
                use_num:'',
            }
        ]
    });

    const employeemanage_quickly_hs_serach_body = new FormData();


    employeemanage_quickly_hs_serach_body.append('search_value', employeemanage_quickly_hs_serach_select_info.value2);

    employeemanage_quickly_hs_serach_body.append('userToken', String(Cookies.get('userToken_chattool')));

    employeemanage_quickly_hs_serach_body.append('time', String(employeemanage_quickly_hs_serach_select_info.time));

    employeemanage_quickly_hs_serach_body.append('action', 'fetch_node');





    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/fetch/fetch_quickly_hs_employeemanage.php', {


                method: 'POST',
                body: employeemanage_quickly_hs_serach_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_employeemanage_quickly_hs_serach(return_data);

                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(employeemanage_quickly_hs_serach_select_log.message!==''){

            data_async();
            setemployeemanage_quickly_hs_serach_select_log({message:'',value:'',time:0})
        }
    }, [employeemanage_quickly_hs_serach_select_log]);




    const [quickly_hs_serach_select_info, setquickly_hs_serach_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [quickly_hs_serach_select_log, setquickly_hs_serach_select_log] = useState({message: '', value: '', time: 0})
    const quickly_hs_serach = (e1: any) => {

        setquickly_hs_serach_select_log({message: 'click', value: '', time: data_time})



        setquickly_hs_serach_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_quickly_hs_serach,setreturn_data_quickly_hs_serach]=useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "160",
                "uuid": null,
                "title_name": "11",
                "sub_txt1": null,
                "sub_txt2": null,
                "parent_id": null,
                "parent_uuid": null,
                "mag1": null,
                "mag2": null,
                "status": "en",
                "tab_state": null,
                "country_code": null,
                "country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761",
                "user_access": null,
                use_num:'',
            }
        ]
    });

    const quickly_hs_serach_body = new FormData();


    quickly_hs_serach_body.append('search_value', quickly_hs_serach_select_info.value2);

    quickly_hs_serach_body.append('userToken', String(Cookies.get('userToken_chattool')));

    quickly_hs_serach_body.append('time', String(quickly_hs_serach_select_info.time));

    quickly_hs_serach_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/fetch/fetch_quickly_hs.php', {


                method: 'POST',
                body: quickly_hs_serach_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_quickly_hs_serach(return_data);

                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    // navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    // navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(quickly_hs_serach_select_log.message!==''){

            data_async();
            setquickly_hs_serach_select_log({message:'',value:'',time:0})
        }
    }, [quickly_hs_serach_select_log]);

    const [insert_quickly_modal_open, setinsert_quickly_modal_open] = useState(false)

    const [insert_quickly_select_info, setinsert_quickly_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [insert_quickly_select_log, setinsert_quickly_select_log] = useState({message: '', value: '', time: 0})
    const insert_quickly = (e1: any) => {

        setinsert_quickly_select_log({message: 'click', value: '', time: data_time})

        setinsert_quickly_modal_open(true);

        setinsert_quickly_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setinsert_quickly_modal_oncancel = () => {

        setinsert_quickly_modal_open(false);
    }


    const [insert_quickly_modal_form]=Form.useForm();

    const insert_quickly_modal_initialValues={




    }

    const [insert_quickly_modal_onfinish_select_log,setinsert_quickly_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [insert_quickly_modal_onfinish_select_info,setinsert_quickly_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const insert_quickly_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setinsert_quickly_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setinsert_quickly_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_insert_quickly,setreturn_data_insert_quickly]=useState({});

    const insert_quickly_body = new FormData();




    insert_quickly_body.append('finish_data', JSON.stringify(insert_quickly_modal_onfinish_select_info.value1));

    insert_quickly_body.append('userToken', String(Cookies.get('userToken_chattool')));

    insert_quickly_body.append('time', String(insert_quickly_modal_onfinish_select_info.time));

    insert_quickly_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/insert/e_insert_quickly_hs_form.php', {


                method: 'POST',
                body: insert_quickly_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setinsert_quickly_modal_open(false)

                    setreturn_data_insert_quickly(return_data);
                    setemployeemanage_quickly_hs_serach_select_log({message:'1',value:'',time:data_time})
                    setshow_quickly_all_select_log({message:'1',value:'',time:data_time})

                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(insert_quickly_modal_onfinish_select_log.message!==''){

            data_async();
            setinsert_quickly_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [insert_quickly_modal_onfinish_select_log]);





    const input_onchange=(e1:any)=>{

        setQuery(e1)

        handleSearch(e1)

    }
    interface InfoItem {
        id: string;
        uuid: string | null;
        title_name: string;
        sub_txt1: string | null;
        sub_txt2: string | null;
        parent_id: string | null;
        parent_uuid: string | null;
        mag1: string | null;
        mag2: string | null;
        status: string;
        tab_state: string | null;
        country_code: string | null;
        country_uuid: string;
        user_access: string | null;

        // 加上这一行，允许使用 string 索引
        [key: string]: any;
    }
    const [color_value,setcolor_value]=useState(0);

    const [selectedIndex, setSelectedIndex] = useState(0); // 默认选中第一
    const [select_count,setselect_count]=useState(0)



    const employeemanage_ddd=(e1:any)=>{


        setemployeemanage_quickly_hs_serach_select_info({value1: 'e1', value2: e1, value3: '', time: data_time})
        setemployeemanage_quickly_hs_serach_select_log({message:'1',value:'',time:data_time})

    }

    const ddd=(e1:any)=>{


        setquickly_hs_serach_select_info({value1: 'e1', value2: e1, value3: '', time: data_time})
        setquickly_hs_serach_select_log({message:'1',value:'',time:data_time})

    }
    const [keyword, setKeyword] = useState("");
    const [filtered, setFiltered] = useState(return_data_quickly_hs_serach.info);

    const handleSearch = (value: string) => {
        setKeyword(value);

        // 拆分关键词（空格或逗号
        const keywords = value
            .split(/[\s,]+/)
            .map(k => k.trim().toLowerCase())
            .filter(Boolean);

        if (keywords.length === 0) {
            setFiltered(return_data_quickly_hs_serach.info);
            return;
        }

        // 过滤逻辑
        const searchFields: (keyof InfoItem)[] = ["title_name", "sub_txt1", "sub_txt2"];

        const filteredData = return_data_quickly_hs_serach.info.filter(item => {
            // 合并要匹配的字段
            const text = searchFields
                .map(f => ((item as any)[f] ?? "").toLowerCase())
                .join(" ");

            // AND 模式：所有关键词都必须出
            return keywords.every(k => text.includes(k));

            // OR 模式：任意关键词出现即可
            // return keywords.some(k => text.includes(k));
        });

        setFiltered(filteredData);

        if(filteredData.length!==0){

           setselect_count(0)
        //   setcolor_value(filteredData[0].uuid); // 同步 color_value
        }
        console.log(filteredData)
    };




    const [show_quickly_all_modal_open, setshow_quickly_all_modal_open] = useState(false)

    const [show_quickly_all_select_info, setshow_quickly_all_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [show_quickly_all_select_log, setshow_quickly_all_select_log] = useState({message: '', value: '', time: 0})
    const show_quickly_all = (e1: any) => {

        setshow_quickly_all_select_log({message: 'click', value: '', time: data_time})

        setshow_quickly_all_modal_open(true);

        setshow_quickly_all_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setshow_quickly_all_modal_oncancel = () => {

        setshow_quickly_all_modal_open(false);
    }


    const [show_quickly_all_modal_next_button_select_log,setshow_quickly_all_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const show_quickly_all_modal_next_button = () => {

        let data_time=dayjs().unix();

        setshow_quickly_all_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_show_quickly_all,setreturn_data_show_quickly_all]=useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "160",
                "uuid": null,
                "title_name": "11",
                "sub_txt1": null,
                "sub_txt2": null,
                "parent_id": null,
                "parent_uuid": null,
                "mag1": null,
                "mag2": null,
                "status": "en",
                "tab_state": null,
                "country_code": null,
                "country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761",
                "user_access": null,
                use_num:'',
            }
        ]
    });
    const show_quickly_all_body = new FormData();




    show_quickly_all_body.append('id', show_quickly_all_select_info.value1);

    show_quickly_all_body.append('userToken', String(Cookies.get('userToken_chattool')));

    show_quickly_all_body.append('time', String(show_quickly_all_modal_next_button_select_log.time));

    show_quickly_all_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/fetch/fetch_quickly_hs_all_employeemanage.php', {


                method: 'POST',
                body: show_quickly_all_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                   // setshow_quickly_all_modal_open(false)

                    setreturn_data_show_quickly_all(return_data);
                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(show_quickly_all_select_log.message!==''){

            data_async();
            setshow_quickly_all_select_log({message:'',value:'',time:0})
        }
    }, [show_quickly_all_select_log]);





    const [insert_quickly_sub_use_num_select_info, setinsert_quickly_sub_use_num_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [insert_quickly_sub_use_num_select_log, setinsert_quickly_sub_use_num_select_log] = useState({message: '', value: '', time: 0})
    const insert_quickly_sub_use_num = (e1: any,title_name:any) => {

        setinsert_quickly_sub_use_num_select_log({message: 'click', value: '', time: data_time})



        setinsert_quickly_sub_use_num_select_info({value1: e1, value2: title_name, value3: '', time: data_time})
    }


    const [return_data_insert_quickly_sub_use_num,setreturn_data_insert_quickly_sub_use_num]=useState({});

    const insert_quickly_sub_use_num_body = new FormData();


    insert_quickly_sub_use_num_body.append('uuid', insert_quickly_sub_use_num_select_info.value1);
    insert_quickly_sub_use_num_body.append('message', insert_quickly_sub_use_num_select_info.value2);
    insert_quickly_sub_use_num_body.append('userToken', String(Cookies.get('userToken_chattool')));

    insert_quickly_sub_use_num_body.append('time', String(insert_quickly_sub_use_num_select_info.time));

    insert_quickly_sub_use_num_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/insert/insert_quickly_sub_use_num.php', {


                method: 'POST',
                body: insert_quickly_sub_use_num_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_insert_quickly_sub_use_num(return_data);


                    if(show_quickly_all_modal_open){
                        setshow_quickly_all_select_log({message: '删除成功', value: '', time: data_time})


                    }else{

                        setquickly_hs_serach_select_log({message: '删除成功', value: '', time: data_time})

                    }
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(insert_quickly_sub_use_num_select_log.message!==''){

            data_async();
            setinsert_quickly_sub_use_num_select_log({message:'',value:'',time:0})
        }
    }, [insert_quickly_sub_use_num_select_log]);







    const [employeemanage_insert_quickly_sub_use_num_select_info, setemployeemanage_insert_quickly_sub_use_num_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [employeemanage_insert_quickly_sub_use_num_select_log, setemployeemanage_insert_quickly_sub_use_num_select_log] = useState({message: '', value: '', time: 0})
    const employeemanage_insert_quickly_sub_use_num =(e1: any,title_name:any) => {

        setemployeemanage_insert_quickly_sub_use_num_select_log({message: 'click', value: '', time: data_time})



        setemployeemanage_insert_quickly_sub_use_num_select_info({value1: e1, value2: title_name, value3: '', time: data_time})
    }


    const [return_data_employeemanage_insert_quickly_sub_use_num,setreturn_data_employeemanage_insert_quickly_sub_use_num]=useState({});

    const employeemanage_insert_quickly_sub_use_num_body = new FormData();


    employeemanage_insert_quickly_sub_use_num_body.append('uuid', employeemanage_insert_quickly_sub_use_num_select_info.value1);
    employeemanage_insert_quickly_sub_use_num_body.append('message', employeemanage_insert_quickly_sub_use_num_select_info.value2);
    employeemanage_insert_quickly_sub_use_num_body.append('userToken', String(Cookies.get('userToken_chattool')));

    employeemanage_insert_quickly_sub_use_num_body.append('time', String(employeemanage_insert_quickly_sub_use_num_select_info.time));

    employeemanage_insert_quickly_sub_use_num_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/insert/e_insert_quickly_sub_use_num.php', {


                method: 'POST',
                body: employeemanage_insert_quickly_sub_use_num_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_employeemanage_insert_quickly_sub_use_num(return_data);

                    if(show_quickly_all_modal_open){
                        setshow_quickly_all_select_log({message: '删除成功', value: '', time: data_time})


                    }else{

                        setquickly_hs_serach_select_log({message: '删除成功', value: '', time: data_time})

                    }
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(employeemanage_insert_quickly_sub_use_num_select_log.message!==''){

            data_async();
            setemployeemanage_insert_quickly_sub_use_num_select_log({message:'',value:'',time:0})
        }
    }, [employeemanage_insert_quickly_sub_use_num_select_log]);





    const [del_quickly_modal_open, setdel_quickly_modal_open] = useState(false)

    const [del_quickly_select_info, setdel_quickly_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [del_quickly_select_log, setdel_quickly_select_log] = useState({message: '', value: '', time: 0})
    const del_quickly = (e1: any) => {

        setdel_quickly_select_log({message: 'click', value: '', time: data_time})

        setdel_quickly_modal_open(true);

        setdel_quickly_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setdel_quickly_modal_oncancel = () => {

        setdel_quickly_modal_open(false);
    }


    const [del_quickly_modal_next_button_select_log,setdel_quickly_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const del_quickly_modal_next_button = () => {

        let data_time=dayjs().unix();

        setdel_quickly_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_del_quickly,setreturn_data_del_quickly]=useState({});

    const del_quickly_body = new FormData();


    del_quickly_body.append('uuid', del_quickly_select_info.value1);

    del_quickly_body.append('userToken', String(Cookies.get('userToken_chattool')));

    del_quickly_body.append('time', String(del_quickly_modal_next_button_select_log.time));

    del_quickly_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/delete/del_quickly.php', {


                method: 'POST',
                body: del_quickly_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setdel_quickly_modal_open(false)

                    setreturn_data_del_quickly(return_data);
                    setshow_quickly_all_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    //navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(del_quickly_modal_next_button_select_log.message!==''){

            data_async();
            setdel_quickly_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [del_quickly_modal_next_button_select_log]);


const tabs_onchange=(e1:any)=>{

    setActiveQuickTab(String(e1));

    switch (e1) {

        case '1':

            console.log('1')
            employeemanage_ddd('1')
        break;

        case '2':
            ddd('1')
            console.log('2')
            break;

default:

    employeemanage_ddd('1')

            break;


    }

}


    const [select_value,setselect_value]=useState(undefined)

    const [windows_setting_win_top_status,setwindows_setting_win_top_status]=useState(false)


    const labelRender = (props:any) => {
        const { label, value } = props;
        if (label) {


            console.log({label:label,value:value})

            return '';
        }
        return <span>No option match</span>;
    };

    const [shareSelectedKeys, setShareSelectedKeys] = useState<string[]>([]);
    const [shareKeyModalOpen, setShareKeyModalOpen] = useState(false);
    const [shareKey, setShareKey] = useState('');
    const [importShareModalOpen, setImportShareModalOpen] = useState(false);
    const [importShareKey, setImportShareKey] = useState('');
    const [importShareItems, setImportShareItems] = useState<any[]>([]);
    const [importSelectedKeys, setImportSelectedKeys] = useState<string[]>([]);
    const [shareHistoryModalOpen, setShareHistoryModalOpen] = useState(false);
    const [shareHistoryItems, setShareHistoryItems] = useState<any[]>([]);

    const createQuicklyShare = async () => {
        if (shareSelectedKeys.length <= 0) {
            message.warning('请选择要分享的话术');
            return;
        }
        const body = new FormData();
        body.append('userToken', String(Cookies.get('userToken_chattool')));
        body.append('uuids', JSON.stringify(shareSelectedKeys));
        const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/share/create_quickly_hs_share.php', {method: 'POST', body});
        const return_data = await data_await.json();
        if (return_data.message === 2000) {
            setShareKey(return_data.info.share_key);
            setShareKeyModalOpen(true);
            message.success(return_data.value);
        } else {
            message.error(return_data.value);
        }
    };

    const fetchQuicklyShare = async () => {
        if (!importShareKey.trim()) {
            message.warning('请输入分享 key');
            return;
        }
        const body = new FormData();
        body.append('userToken', String(Cookies.get('userToken_chattool')));
        body.append('share_key', importShareKey.trim());
        const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/share/fetch_quickly_hs_share.php', {method: 'POST', body});
        const return_data = await data_await.json();
        if (return_data.message === 2000) {
            setImportShareItems(return_data.info || []);
            setImportSelectedKeys((return_data.info || []).map((item:any) => item.uuid));
            message.success(return_data.value);
        } else {
            message.error(return_data.value);
        }
    };

    const importQuicklyShare = async () => {
        if (importSelectedKeys.length <= 0) {
            message.warning('请选择要导入的话术');
            return;
        }
        const body = new FormData();
        body.append('userToken', String(Cookies.get('userToken_chattool')));
        body.append('share_key', importShareKey.trim());
        body.append('uuids', JSON.stringify(importSelectedKeys));
        const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/share/import_quickly_hs_share.php', {method: 'POST', body});
        const return_data = await data_await.json();
        if (return_data.message === 2000) {
            message.success(`${return_data.value}，新增 ${return_data.info.inserted} 条，跳过 ${return_data.info.skipped} 条`);
            setImportShareModalOpen(false);
            setImportShareItems([]);
            setImportSelectedKeys([]);
            setshow_quickly_all_select_log({message:'1',value:'',time:dayjs().unix()});
            setemployeemanage_quickly_hs_serach_select_log({message:'1',value:'',time:dayjs().unix()});
        } else {
            message.error(return_data.value);
        }
    };

    const fetchQuicklyShareHistory = async () => {
        const body = new FormData();
        body.append('userToken', String(Cookies.get('userToken_chattool')));
        const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/share/fetch_quickly_hs_share_history.php', {method: 'POST', body});
        const return_data = await data_await.json();
        if (return_data.message === 2000) {
            setShareHistoryItems(return_data.info || []);
            setShareHistoryModalOpen(true);
        } else {
            message.error(return_data.value);
        }
    };

    const cancelQuicklyShare = async (share_key:any) => {
        const body = new FormData();
        body.append('userToken', String(Cookies.get('userToken_chattool')));
        body.append('share_key', String(share_key));
        const data_await = await fetch('https://chatv2.leytcn.com/api/admin/quickly_hs/share/cancel_quickly_hs_share.php', {method: 'POST', body});
        const return_data = await data_await.json();
        if (return_data.message === 2000) {
            message.success(return_data.value);
            fetchQuicklyShareHistory();
        } else {
            message.error(return_data.value);
        }
    };

    const quicklyManageItems = return_data_show_quickly_all.message === 2000 ? return_data_show_quickly_all.info : [];
    const quicklyManageKeys = quicklyManageItems.map((item:any) => String(item.uuid));
    const selectedQuicklyManageCount = quicklyManageKeys.filter((key:string) => shareSelectedKeys.includes(key)).length;
    const isQuicklyManageAllChecked = quicklyManageKeys.length > 0 && selectedQuicklyManageCount === quicklyManageKeys.length;
    const isQuicklyManageIndeterminate = selectedQuicklyManageCount > 0 && selectedQuicklyManageCount < quicklyManageKeys.length;
    const toggleQuicklyManageAll = (checked: boolean) => {
        setShareSelectedKeys((keys) => {
            const outsideKeys = keys.filter((key) => !quicklyManageKeys.includes(key));
            return checked ? Array.from(new Set([...outsideKeys, ...quicklyManageKeys])) : outsideKeys;
        });
    };

    const quicklyManageList = (
        <div className="kuai-message-list">
            {return_data_show_quickly_all.message!==2000?<>
                <div className="kuai-message-empty">暂无信息</div>
            </>:<>{quicklyManageItems.map((item1:any)=>(<Card key={item1.uuid} size={'small'} className={`kuai-message-item ${shareSelectedKeys.includes(String(item1.uuid)) ? 'kuai-message-item-selected' : ''}`}>
                <div>
                    <Checkbox
                        checked={shareSelectedKeys.includes(String(item1.uuid))}
                        onChange={(event) => {
                            setShareSelectedKeys((keys) => event.target.checked
                                ? Array.from(new Set([...keys, String(item1.uuid)]))
                                : keys.filter((key) => key !== String(item1.uuid))
                            );
                        }}
                        className="kuai-message-check"
                    >
                        选择
                    </Checkbox>
                    <div className="kuai-message-content">
                        <pre>
                            {item1.title_name}
                        </pre>
                        <span className="kuai-message-meta">调用次数：{item1.use_num}</span>
                    </div>

                    <div className="kuai-message-actions">
                        <Button size={'small'} icon={<CopyOutlined/>} onClick={(event) => {
                                event.stopPropagation();
                                copy_clipbord(item1.title_name)
                                employeemanage_insert_quickly_sub_use_num(item1.uuid,item1.title_name)
                            }}>复制</Button>
                        <Button size={'small'} danger icon={<DeleteOutlined/>} onClick={(event) => {
                                event.stopPropagation();
                                del_quickly(item1.uuid)
                            }}>删除</Button>
                    </div>
                </div>
            </Card>))}</>}
        </div>
    );

    return (

        <div className="kuai-message-page-shell">

            <Tabs onChange={tabs_onchange} items={[{key:'1',label:'个人自建',children:<div className="kuai-message-page">
                    <Card title={
                        <div className="kuai-message-card-title">
                            <span>快捷话术</span>
                            <Space size={6}>
                            </Space>
                        </div>
                    } className="kuai-message-side-card kuai-message-side-card-tab">
                        <Space className="kuai-message-toolbar" wrap>
                            <Checkbox
                                checked={isQuicklyManageAllChecked}
                                indeterminate={isQuicklyManageIndeterminate}
                                disabled={quicklyManageKeys.length <= 0}
                                onChange={(event) => toggleQuicklyManageAll(event.target.checked)}
                            >全选</Checkbox>
                            {shareSelectedKeys.length > 0 && <Button size={'small'} type={'primary'} icon={<ShareAltOutlined/>} title={'分享选中'} aria-label={'分享选中'} onClick={createQuicklyShare}>分享 {shareSelectedKeys.length}</Button>}
                            <Button size={'small'} icon={<ImportOutlined/>} title={'导入分享'} aria-label={'导入分享'} onClick={() => setImportShareModalOpen(true)}/>
                            <Button size={'small'} icon={<HistoryOutlined/>} title={'历史分享'} aria-label={'历史分享'} onClick={fetchQuicklyShareHistory}/>
                        </Space>
                        {quicklyManageList}
                    </Card>
                    <Card className="kuai-message-main-card" style={{

                    backgroundColor: '#fff',


                    /*   display: 'flex',
                       flexDirection: 'column',
                       justifyContent: 'center',
                       alignItems: 'center',*/

                }}>

                    <div style={{backgroundColor:'#f2f2f2'}}>

                        {/*   <Button onClick={() => setselect_value(undefined)}>1</Button>
                <Button onClick={() => setselect_value(null)}>21</Button>
*/}
                        <AutoComplete

                            variant="borderless"
                            ref={SelectRef}
                            style={{ width:'100%' }}
                            popupMatchSelectWidth={500}


                            value={select_value}
                            showSearch={{
                                filterOption: (input, option) =>
                                    (option?.title_name ?? '').toLowerCase().includes(input.toLowerCase()), // 用挂载的 title_name
                            }}


                            /*     onClear={() => {
                                     // 什么都不做 = 看起来“取消了选择”，但内容不变
                                 }}

                                 onBlur={()=>{


                                 }}*/

                            /*     onChange={()=>{

                 setselect_value(undefined)
                                 }}*/
                            /* onActive={(value:any)=>{

                                   console.log(value.value); // uuid-1

                                   console.log(value.key); // JSX
                                 setselect_value(undefined)
                               }}*/

                            /*labelRender={null}*/
                            onSelect={(value: any, option: any) => {


                                copy_clipbord(option.title_name);

                                employeemanage_insert_quickly_sub_use_num(option.key, option.title_name)
                                /*  setselect_value('')*/

                                /* setselect_value(option.title_name)
                                 setselect_value(undefined)*/
                                //setselect_value('null')
                                //setselect_value(value.value)
                            }}
                            /*onChange={(value: any) =>  {
                                console.log(value.value); // uuid-1
                                console.log(value.uuid); // JSX
                                console.log(value.key); // JSX
                                console.log(value.label); // JSX


                            }}*/
                            /*onChange={(e)=>handleChange(e)}*/
                            /*   searchValue={select_value}*/
                            options={return_data_employeemanage_quickly_hs_serach.info.map(item1 => ({
                                title_name: item1.title_name, key: item1.uuid, value: item1.title_name, label: <>

                                    <div style={{padding: 10}}>


                                        <div style={{marginBottom: '8px', wordBreak: 'break-word'}}>
  <pre style={{
      whiteSpace: 'pre-wrap',      // 允许空白符换行，并保留文本中的换
      wordBreak: 'break-word',     // 长单词或 URL 会断
      margin: 0,                   // 可选：去除 pre 默认margin
      overflowWrap: 'break-word'   // 更现代的写法，确保长词换
  }}>
    {item1.title_name}
  </pre>

                                            <label>调用次数：{item1.use_num}</label>
                                        </div>


                                        <CopyOutlined
                                            style={{}}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                copy_clipbord(item1.title_name)
                                                employeemanage_insert_quickly_sub_use_num(item1.uuid, item1.title_name)
                                            }}>复制</CopyOutlined>

                                        <SendOutlined
                                            style={{marginLeft: 10}}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                send_message(item1.title_name)
                                                employeemanage_insert_quickly_sub_use_num(item1.uuid, item1.title_name)
                                            }}>复制</SendOutlined>
                                    </div>
                                </>,
                            }))}
                        ><TextArea placeholder={'请输入搜索内容'} autoSize={{minRows: 4, maxRows: 4}} variant="borderless" style={{width:'100%'}} /></AutoComplete>


                    </div>



                </Card></div>

            },{key:'2',label:'公司创建',children:<div className="kuai-message-page">
                    <Card title={
                        <div className="kuai-message-card-title">
                            <span>快捷话术</span>
                        </div>
                    } className="kuai-message-side-card kuai-message-side-card-tab">
                        <Space className="kuai-message-toolbar" wrap>
                            <Checkbox
                                checked={isQuicklyManageAllChecked}
                                indeterminate={isQuicklyManageIndeterminate}
                                disabled={quicklyManageKeys.length <= 0}
                                onChange={(event) => toggleQuicklyManageAll(event.target.checked)}
                            >全选</Checkbox>
                            {shareSelectedKeys.length > 0 && <Button size={'small'} type={'primary'} icon={<ShareAltOutlined/>} title={'分享选中'} aria-label={'分享选中'} onClick={createQuicklyShare}>分享 {shareSelectedKeys.length}</Button>}
                            <Button size={'small'} icon={<ImportOutlined/>} title={'导入分享'} aria-label={'导入分享'} onClick={() => setImportShareModalOpen(true)}/>
                            <Button size={'small'} icon={<HistoryOutlined/>} title={'历史分享'} aria-label={'历史分享'} onClick={fetchQuicklyShareHistory}/>
                        </Space>
                        {quicklyManageList}
                    </Card>
                    <Card style={{

                    backgroundColor: '#fff',


                    /*   display: 'flex',
                       flexDirection: 'column',
                       justifyContent: 'center',
                       alignItems: 'center',*/

                }}>

                    <div style={{backgroundColor:'#f2f2f2'}}>

                        {/*   <Button onClick={() => setselect_value(undefined)}>1</Button>
                <Button onClick={() => setselect_value(null)}>21</Button>
*/}
                        <AutoComplete

                            variant="borderless"
                            ref={SelectRef}
                            style={{ width:'100%' }}
                            popupMatchSelectWidth={500}


                            value={select_value}
                            showSearch={{
                                filterOption: (input, option) =>
                                    (option?.title_name ?? '').toLowerCase().includes(input.toLowerCase()), // 用挂载的 title_name
                            }}


                            /*     onClear={() => {
                                     // 什么都不做 = 看起来“取消了选择”，但内容不变
                                 }}

                                 onBlur={()=>{


                                 }}*/

                            /*     onChange={()=>{

                 setselect_value(undefined)
                                 }}*/
                            /* onActive={(value:any)=>{

                                   console.log(value.value); // uuid-1

                                   console.log(value.key); // JSX
                                 setselect_value(undefined)
                               }}*/

                            /*labelRender={null}*/
                            onSelect={(value: any, option: any) => {


                                copy_clipbord(option.title_name);

                                insert_quickly_sub_use_num(option.key, option.title_name)
                                /*  setselect_value('')*/

                                /* setselect_value(option.title_name)
                                 setselect_value(undefined)*/
                                //setselect_value('null')
                                //setselect_value(value.value)
                            }}
                            /*onChange={(value: any) =>  {
                                console.log(value.value); // uuid-1
                                console.log(value.uuid); // JSX
                                console.log(value.key); // JSX
                                console.log(value.label); // JSX


                            }}*/
                            /*onChange={(e)=>handleChange(e)}*/
                            /*   searchValue={select_value}*/
                            options={return_data_quickly_hs_serach.info.map(item1 => ({
                                title_name: item1.title_name, key: item1.uuid, value: item1.title_name, label: <>

                                    <div style={{padding: 10}}>


                                        <div style={{marginBottom: '8px', wordBreak: 'break-word'}}>
  <pre style={{
      whiteSpace: 'pre-wrap',      // 允许空白符换行，并保留文本中的换
      wordBreak: 'break-word',     // 长单词或 URL 会断
      margin: 0,                   // 可选：去除 pre 默认margin
      overflowWrap: 'break-word'   // 更现代的写法，确保长词换
  }}>
    {item1.title_name}
  </pre>

                                            <label>调用次数：{item1.use_num}</label>
                                        </div>


                                        <CopyOutlined
                                            style={{}}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                copy_clipbord(item1.title_name)
                                                insert_quickly_sub_use_num(item1.uuid, item1.title_name)
                                            }}>复制</CopyOutlined>

                                        <SendOutlined
                                            style={{marginLeft: 10}}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                send_message(item1.title_name)
                                                insert_quickly_sub_use_num(item1.uuid, item1.title_name)
                                            }}>复制</SendOutlined>
                                    </div>
                                </>,
                            }))}
                        ><TextArea placeholder={'请输入搜索内容'} autoSize={{minRows: 4, maxRows: 4}} variant="borderless" style={{width:'100%'}} /></AutoComplete>


                    </div>



                </Card></div> }]}/>









            <FloatButton.Group className="admin-float-actions">
                <FloatButton icon={<ReloadOutlined/>} tooltip="刷新" onClick={() => {
                    activeQuickTab === '1' ? employeemanage_ddd('1') : ddd('1');
                    setshow_quickly_all_select_log({message:'1',value:'',time:dayjs().unix()});
                    message.success('刷新成功');
                }}/>
                {activeQuickTab === '1' && <FloatButton icon={<UploadOutlined/>} tooltip="上传快捷话术" onClick={insert_quickly}/>} 
            </FloatButton.Group>

            <Drawer open={insert_quickly_modal_open} onClose={setinsert_quickly_modal_oncancel} footer={null} title={'上传消息'}>




                <Form form={insert_quickly_modal_form} initialValues={insert_quickly_modal_initialValues} onFinish={insert_quickly_modal_onfinish}>

                    <label>消息</label>

                    <Form.Item name={'message'} rules={[{message:'必填项',required:true}]}>

                        <Input.TextArea style={{height:50}}>



                        </Input.TextArea>


                    </Form.Item>



                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={setinsert_quickly_modal_oncancel}>取消</Button>

                </Form>


            </Drawer>





            <Drawer open={show_quickly_all_modal_open} onClose={setshow_quickly_all_modal_oncancel} title={'管理'}>


                <div>
                    {return_data_show_quickly_all.message!==2000?<>

                    暂无信息</>:<>{return_data_show_quickly_all.info.map(item1=>(<Card style={{marginTop:5}}>


                        <div style={{backgroundColor:color_value===item1.uuid?'#ddd':'#fff'}}>



                            <div style={{ marginBottom: '8px', wordBreak: 'break-word' }}>
  <pre style={{
      whiteSpace: 'pre-wrap',      // 允许空白符换行，并保留文本中的换
      wordBreak: 'break-word',     // 长单词或 URL 会断
      margin: 0,                   // 可选：去除 pre 默认margin
      overflowWrap: 'break-word'   // 更现代的写法，确保长词换
  }}>
    {item1.title_name}
  </pre>
                                <label>调用次数：{item1.use_num}</label>
                            </div>


                            <CopyOutlined
                                style={{}}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    copy_clipbord(item1.title_name)
                                    insert_quickly_sub_use_num(item1.uuid,item1.title_name)
                                }}>复制</CopyOutlined>

                            <DeleteOutlined
                                style={{marginLeft:5}}
                                onClick={(event) => {
                                    event.stopPropagation();

                                    del_quickly(item1.uuid)
                                }}>删除</DeleteOutlined>

                            {/* <SendOutlined
                            style={{marginLeft: 10}}
                            onClick={(event) => {
                                event.stopPropagation();
                                send_message(item1.title_name)
                            }}>复制</SendOutlined>*/}
                        </div>

                    </Card>))}</>}


                </div>
              {/*  <Button onClick={show_quickly_all_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft:10}} onClick={setshow_quickly_all_modal_oncancel}>

                    取消
                </Button>*/}


            </Drawer>





            <Modal open={shareKeyModalOpen} onCancel={() => setShareKeyModalOpen(false)} footer={null} title={'分享 key'}>
                <Input value={shareKey} readOnly />
                <Space style={{marginTop:12}}>
                    <Button type={'primary'} onClick={() => {
                        copy_clipbord(shareKey);
                    }}>复制 key</Button>
                    <Button onClick={() => setShareKeyModalOpen(false)}>关闭</Button>
                </Space>
            </Modal>

            <Modal open={importShareModalOpen} onCancel={() => setImportShareModalOpen(false)} footer={null} title={'导入分享话术'} width={720}>
                <Space.Compact style={{width:'100%'}}>
                    <Input value={importShareKey} onChange={(event) => setImportShareKey(event.target.value)} placeholder={'请输入分享 key'} />
                    <Button type={'primary'} onClick={fetchQuicklyShare}>查询</Button>
                </Space.Compact>

                <div style={{marginTop:16, maxHeight:360, overflowY:'auto'}}>
                    {importShareItems.map((item:any) => (
                        <Card key={item.uuid} size={'small'} style={{marginTop:8}}>
                            <Checkbox
                                checked={importSelectedKeys.includes(item.uuid)}
                                onChange={(event) => {
                                    setImportSelectedKeys((keys) => event.target.checked
                                        ? Array.from(new Set([...keys, item.uuid]))
                                        : keys.filter((key) => key !== item.uuid)
                                    );
                                }}
                            >
                                <pre style={{whiteSpace:'pre-wrap', wordBreak:'break-word', margin:0}}>{item.title_name}</pre>
                            </Checkbox>
                        </Card>
                    ))}
                </div>

                <Space style={{marginTop:16}}>
                    <Button type={'primary'} onClick={importQuicklyShare}>导入选中</Button>
                    <Button onClick={() => setImportShareModalOpen(false)}>取消</Button>
                </Space>
            </Modal>

            <Drawer
                open={shareHistoryModalOpen}
                onClose={() => setShareHistoryModalOpen(false)}
                title={'历史分享'}
                width={'min(820px, calc(100vw - 24px))'}
            >
                <div style={{height:'100%', overflowY:'auto'}}>
                    {shareHistoryItems.length <= 0 ? <>暂无分享记录</> : shareHistoryItems.map((item:any) => (
                        <Card key={item.share_key} size={'small'} style={{marginTop:8}}>
                            <div style={{display:'flex', justifyContent:'space-between', gap:12, alignItems:'flex-start'}}>
                                <div style={{flex:1}}>
                                    <Space wrap>
                                        <span>key：{item.share_key}</span>
                                        <span>数量：{item.count}</span>
                                        <span>状态：{item.status === 'en' ? '分享中' : '已取消'}</span>
                                    </Space>
                                    <div style={{marginTop:8, color:'#666'}}>
                                        {(item.items || []).slice(0, 3).map((sub:any) => (
                                            <pre key={sub.uuid} style={{whiteSpace:'pre-wrap', wordBreak:'break-word', margin:'4px 0'}}>{sub.title_name}</pre>
                                        ))}
                                    </div>
                                </div>
                                <Space>
                                    <Button size={'small'} onClick={() => copy_clipbord(item.share_key)}>复制 key</Button>
                                    {item.status === 'en' && <Button size={'small'} danger onClick={() => cancelQuicklyShare(item.share_key)}>取消分享</Button>}
                                </Space>
                            </div>
                        </Card>
                    ))}
                </div>
            </Drawer>

            <Modal open={del_quickly_modal_open} onCancel={setdel_quickly_modal_oncancel} footer={null} title={'是否确认删除？'}>


                <Button onClick={del_quickly_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft:10}} onClick={setdel_quickly_modal_oncancel}>

                    取消
                </Button>


            </Modal>




        </div>
    );
};

export default Employeemanage_SearchChain;
